// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React, { useCallback } from "react";
import { toast } from "react-toastify";

import Icon from "src/icons";
import { clearWorkflowInstances } from "src/actions/workflows";
import { setReports } from "src/actions/reports";
import { getWorkflowInstanceFilter } from "src/reducers";
import BlueOutlineButton from "src/components/Buttons/BlueOutline";
import type { AppState, WorkflowInstanceFilter } from "src/types";

type Props = {
  filter: WorkflowInstanceFilter,
  additionalFilters: WorkflowInstanceFilter,
  _setReports: typeof setReports,
  _clearWorkflowInstances: Function,
};

const Refresh = ({
  filter,
  additionalFilters,
  _setReports,
  _clearWorkflowInstances,
}: Props) => {
  const handleReload = useCallback(() => {
    _clearWorkflowInstances();
    filter.reportId &&
      _setReports(filter.reportId, {
        query: { ...additionalFilters, page: 1 },
      });
    toast.success(i18n.t(k.REFRESHED_PROCESS_TABLE));
  }, [filter, _setReports, _clearWorkflowInstances]);

  return (
    <BlueOutlineButton
      leftIcon={<Icon type="circularArrows" />}
      onClick={handleReload}
    >
      {i18n.t(k.REFRESH)}
    </BlueOutlineButton>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  filter: getWorkflowInstanceFilter(app),
  additionalFilters: app.workflow.additionalFilters,
});

export default connect(mapStateToProps, {
  _setReports: setReports,
  _clearWorkflowInstances: clearWorkflowInstances,
})(Refresh);
